import { render, staticRenderFns } from "./LoginModal.vue?vue&type=template&id=04be0677"
import script from "./LoginModal.vue?vue&type=script&lang=js"
export * from "./LoginModal.vue?vue&type=script&lang=js"
import style0 from "./LoginModal.vue?vue&type=style&index=0&id=04be0677&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports